<template>
  <router-link :to="to" class="banner-label" :class="{isStacked}">
    <span v-for="line in lines" :key="line.text || line">
      <i v-if="line.isItalic">{{ line.text }}</i>
      <!-- the viewer's country before their dates, moved to their calendar (bannerLabels.js) -->
      <template v-else-if="line.flag">
        <span class="flag" role="img" :aria-label="line.text" :title="line.text">{{
          line.flag }}</span>{{ line.suffix ? ` ${line.suffix}` : "" }}
      </template>
      <template v-else>{{ line }}</template>
    </span>
  </router-link>
</template>

<script setup>
defineProps({
  to: {type: String, required: true},
  lines: {type: Array, required: true},
  isStacked: {type: Boolean, default: true}
});
</script>

<style scoped>
.banner-label {
  display: inline-flex;
  gap: 0.25em;
  color: white;
  font-weight: bold;
  white-space: nowrap;
  text-decoration: none;
  transition: opacity 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.banner-label.isStacked {
  flex-direction: column;
  align-items: center;
  gap: 0;
  font-size: 0.8em;
}
.flag {
  font-weight: normal; /* an emoji, or on Windows its two letters ("AU") */
}
.banner-label:hover {
  color: white;
  text-decoration: none;
  opacity: 0.65;
}
/* already on that page: no hover, a click goes nowhere new (DESIGN.md § 15) */
.banner-label.router-link-exact-active:hover {
  opacity: 1;
}
</style>
